import * as React from 'react'

import FormLabel from '../form-label'
import Spacer from '../spacer'
import { SpacingProps } from '../spacer/spacer'
import styles from './form-field.module.scss'

export type TProps = {
  children: React.ReactNode
  label?: React.ReactNode
  labelClassName?: string
  validation?: string | null | undefined
  htmlFor?: string
  required?: boolean
  fullWidth?: boolean
} & SpacingProps

const FormField = React.forwardRef<HTMLDivElement, TProps>((props, ref) => {
  const {
    children,
    label,
    validation,
    htmlFor,
    labelClassName,
    required,
    ...otherProps
  } = props
  return (
    <Spacer ref={ref} {...otherProps} className={styles.root}>
      {label !== undefined && (
        <div className={styles.labelWrapper}>
          <FormLabel htmlFor={htmlFor} className={labelClassName}>
            {label}
          </FormLabel>
          {required === true && (
            <span aria-hidden="true" className={styles.asterisk}>
              &thinsp;{'*'}
            </span>
          )}
        </div>
      )}

      {children}
      {validation != null && (
        <span className={styles.validation}>{validation}</span>
      )}
    </Spacer>
  )
})

export default FormField
